import { PRESS_CENTER_URL } from 'constants/routes';
const SUSTAINABILITY_REPORT_LOCALES = ['pl', 'nl', 'de', 'it', 'es'];
const PRESS_CENTER_LOCALES = ['en', 'fr', 'lt'];

const getLangParam = activeLocale => {
  const isLocaleSupported = SUSTAINABILITY_REPORT_LOCALES.includes(activeLocale);
  return isLocaleSupported ? "?lang=".concat(activeLocale) : '';
};

const getLocaleSubPath = activeLocale => PRESS_CENTER_LOCALES.includes(activeLocale) ? "/".concat(activeLocale) : '';

export const getPressCenterUrl = activeLocale => "".concat(PRESS_CENTER_URL).concat(getLocaleSubPath(activeLocale));
export const getSustainabilityUrl = activeLocale => "".concat(getPressCenterUrl(activeLocale), "/sustainability").concat(getLangParam(activeLocale));